import { Box, Grid, Text, VStack } from "@chakra-ui/react";
import { DEFAULT_LAYOUT_CARD_WIDTH } from "constants/layout";
import { DEFAULT_SPACING, SECTION_SPACING } from "constants/spacing";
import { NavLogoWhite } from "styles/icons";
import { BG_GRADIENT, GLASS_BG, GLASS_BORDER, GLOW_BLUE, LOGO_GLOW, ORB_BLUE, ORB_PURPLE } from "styles/theme";
import { IDefaultLayoutProps } from "./interfaces";

export function DefaultLayout({ children }: IDefaultLayoutProps) {
  const currentYear = new Date().getFullYear();

  return (
    <Grid
      minWidth="100vw"
      minHeight="100vh"
      justifyContent="center"
      alignContent="center"
      overflowY="auto"
      position="relative"
      bg={BG_GRADIENT}
      px={4}
    >
      <Box position="absolute" top="80px" left="80px" w="384px" h="384px" borderRadius="full"
        bg={ORB_BLUE} filter="blur(80px)" pointerEvents="none" />
      <Box position="absolute" bottom="80px" right="80px" w="320px" h="320px" borderRadius="full"
        bg={ORB_PURPLE} filter="blur(80px)" pointerEvents="none" />

      <VStack position="relative" spacing={8} width={DEFAULT_LAYOUT_CARD_WIDTH} maxWidth="100vw">
        <NavLogoWhite w="auto" height="45px" filter={LOGO_GLOW} />

        <Box
          data-testid="content-card"
          w="full"
          bg={GLASS_BG}
          border="1px solid"
          borderColor={GLASS_BORDER}
          borderRadius="3xl"
          boxShadow={`${GLOW_BLUE}, 0 8px 32px rgba(0,0,0,0.3)`}
          backdropFilter="blur(24px)"
          display="grid"
          gridTemplateColumns="1fr"
          gap={DEFAULT_SPACING}
          padding={SECTION_SPACING}
        >
          { children }
        </Box>
        <Text data-testid="copyright" color="whiteAlpha.800" fontSize="xs">
          &copy; {currentYear} IXICO PLC. All rights reserved.
        </Text>
      </VStack>
    </Grid>
  );
}
